
@if (spinner.isVisible() | async) {
  <div class="spinner lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
}
